import { hotRanking } from "@/mocks/home";

const rankStyle: Record<number, string> = {
  1: "bg-primary-500 text-background-50",
  2: "bg-accent-500 text-foreground-950",
  3: "bg-secondary-500 text-background-50",
};

export default function HotRanking() {
  return (
    <div id="ranking" className="rounded-lg overflow-hidden border border-accent-200 bg-accent-50">
      <div className="flex items-center justify-between gap-3 px-5 py-4 bg-accent-500">
        <div className="flex items-center gap-2">
          <i className="ri-fire-fill text-xl text-foreground-950"></i>
          <h4 className="font-heading text-base md:text-lg font-bold text-foreground-950">
            线索热度榜
          </h4>
        </div>
        <span className="text-xs font-medium text-foreground-950/70 whitespace-nowrap">
          每日更新
        </span>
      </div>

      <ol className="divide-y divide-accent-100">
        {hotRanking.map((row) => (
          <li key={row.id} className="flex items-start gap-3 px-4 md:px-5 py-4">
            <span
              className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold shrink-0 ${
                rankStyle[row.rank] ?? "bg-background-200 text-foreground-700"
              }`}
            >
              {row.rank}
            </span>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-foreground-950 leading-snug">{row.title}</p>
              <div className="mt-1.5 flex items-center gap-2">
                <span className="px-2 py-0.5 rounded bg-background-50 text-foreground-600 text-xs whitespace-nowrap">
                  {row.tag}
                </span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">
                  热度 {row.heat.toLocaleString("zh-CN")}
                </span>
              </div>
            </div>
          </li>
        ))}
      </ol>

      <div className="px-4 md:px-5 py-4 bg-accent-100/70">
        <p className="text-xs leading-relaxed text-foreground-700">
          热度由阅读、转发与补充材料次数综合计算，仅反映线索关注度，不代表结论。
        </p>
      </div>
    </div>
  );
}